function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Sizes, States, Types } from './constants';
import Loading from '@doordash/component-loading';
export var colorForType = function colorForType(_ref) {
  var isToggleable = _ref.isToggleable,
      isToggled = _ref.isToggled,
      buttonType = _ref.buttonType,
      isDisabled = _ref.isDisabled,
      isRaised = _ref.isRaised;

  switch (buttonType) {
    case Types.FlatPrimary:
      return isDisabled ? 'ButtonFlatPrimaryForegroundDisabled' : 'ButtonFlatPrimaryForeground';

    case Types.FlatSecondary:
      return isDisabled ? 'ButtonFlatSecondaryForegroundDisabled' : 'ButtonFlatSecondaryForeground';

    case Types.Link:
      return isDisabled ? 'ButtonLinkForegroundDisabled' : 'ButtonLinkForeground';

    case Types.Plain:
      return isRaised ? isDisabled ? 'ButtonFabForegroundDisabled' : 'ButtonFabForeground' : isDisabled ? 'ButtonPlainForegroundDisabled' : 'ButtonPlainForeground';

    case Types.Secondary:
    case Types.SecondaryPill:
      {
        if (isToggleable) {
          return isToggled ? isDisabled ? 'ButtonSecondaryToggleForegroundDisabled' : 'ButtonSecondaryToggleForeground' : isDisabled ? 'ButtonSecondaryToggleForegroundOffDisabled' : 'ButtonSecondaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonSecondaryForegroundDisabled' : 'ButtonSecondaryForeground';
      }

    case Types.Tertiary:
    case Types.TertiaryPill:
      {
        if (isToggleable) {
          return isToggled ? isDisabled ? 'ButtonTertiaryToggleForegroundDisabled' : 'ButtonTertiaryToggleForeground' : isDisabled ? 'ButtonTertiaryToggleForegroundOffDisabled' : 'ButtonTertiaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonTertiaryForegroundDisabled' : 'ButtonTertiaryForeground';
      }

    case Types.Destructive:
      return isDisabled ? 'ButtonDestructiveForegroundDisabled' : 'ButtonDestructiveForeground';

    case Types.Primary:
    case Types.PrimaryPill:
    case Types.Full:
    default:
      {
        if (isToggleable) {
          return isToggled ? isDisabled ? 'ButtonPrimaryToggleForegroundDisabled' : 'ButtonPrimaryToggleForeground' : isDisabled ? 'ButtonPrimaryToggleForegroundOffDisabled' : 'ButtonPrimaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonPrimaryForegroundDisabled' : 'ButtonPrimaryForeground';
      }
  }
};
export var omitSpecificTypes = function omitSpecificTypes(typesToOmit) {
  var types = _objectSpread({}, Types);

  typesToOmit.forEach(function (typeName) {
    delete types[typeName];
  });
  return types;
};
export var iconSizeForIconButton = function iconSizeForIconButton(buttonSize) {
  switch (buttonSize) {
    case Sizes.Small:
      return 'Small';

    case Sizes.Medium:
    case Sizes.Large:
    case Sizes.XLarge:
    default:
      return 'Medium';
  }
};
export var loadingSizeForButton = function loadingSizeForButton(buttonSize) {
  switch (buttonSize) {
    case Sizes.Small:
      return 'Small';

    case Sizes.Large:
    case Sizes.XLarge:
      return 'Large';

    case Sizes.Medium:
    default:
      return 'Medium';
  }
};
export var loadingStateForButton = function loadingStateForButton(buttonState) {
  switch (buttonState) {
    case States.Error:
      return Loading.States.Error;

    case States.Success:
      return Loading.States.Success;

    case States.Loading:
    default:
      return Loading.States.Loading;
  }
};